import { DatePicker, Form, Input, Select } from "antd";
import moment from "moment";
import React, { PureComponent } from "react";
import { API_DATE_FS } from "./shared";

const ISSUED_BY_OPTIONS = [
  "NZ Association of Counsellors",
  "NZ Dietitians Board",
  "NZ Physician",
  "NZ Nursing Council",
  "NZ Occupational Therapy Board",
  "NZ Physiotherapy Board",
  "NZ Pharmacy Council",
  "NZ Psychologists Board",
  "NZ Speech Therapists Association",
  "NZ Social Workers Registration Board",
];

export class NZAPCFormItems extends PureComponent {
  static slug = "nzapc";

  constructor(props) {
    super(props);
  }

  static getSubmissionData(checkData, constituent) {
    return {
      identifier: checkData.identifier,
      issued_by: checkData.issued_by,
      ...(checkData.expiry && { expiry: checkData.expiry.format(API_DATE_FS) }),
      fullName: constituent.get("fullName"),
    };
  }

  disablePastDate = (current) => current && current < moment().endOf("day");

  render() {
    const { form, disabled, rules } = this.props;
    const { getFieldDecorator } = form;
    const { slug } = this.constructor;

    const ident = {
      label: "Identifier",
      slug: `${slug}.identifier`,
    };
    const issuedBy = {
      label: "Issued By",
      slug: `${slug}.issued_by`,
    };
    const expiry = {
      label: "Expiry",
      slug: `${slug}.expiry`,
    };

    return (
      <>
        <Form.Item label={ident.label}>
          {getFieldDecorator(ident.slug, {
            rules: [
              {
                required: true,
                whitespace: true,
                message: `${ident.label} is required`,
              },
              ...(rules || []),
            ],
          })(<Input disabled={disabled} />)}
        </Form.Item>
        <Form.Item label={issuedBy.label}>
          {getFieldDecorator(issuedBy.slug, {
            rules: [
              {
                required: true,
                whitespace: true,
                message: `${issuedBy.label} is required`,
              },
              ...(rules || []),
            ],
          })(
            <Select
              showSearch
              disabled={disabled}
              optionFilterProp="children"
              filterOption={(input, option) =>
                option.props.children
                  .toString()
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
            >
              {ISSUED_BY_OPTIONS.map(member => (
                <Select.Option key={member} value={member}>
                  {member}
                </Select.Option>
              ))}
            </Select>,
          )}
        </Form.Item>
        <Form.Item label={expiry.label}>
          {getFieldDecorator(expiry.slug, {
            rules: [...(rules || [])],
          })(
            <DatePicker
              format="DD-MM-YYYY"
              placeholder="DD-MM-YYYY"
              disabled={disabled}
              disabledDate={this.disablePastDate}
            />,
          )}
        </Form.Item>
      </>
    );
  }
}
